export const LOCAL_OCR_UNAVAILABLE_MESSAGE = "OCR 暫時不提供服務。";

// Keep the OCR workflows available for a future, explicitly enabled deployment.
export const isLocalOcrServiceEnabled = () =>
  process.env.REACT_APP_LOCAL_OCR_SERVICE_ENABLED === "true";
